import { ImmutableMap, QueryParams } from '@daikin-tic/dxone-com-lib';

export type ResultFile = {
  fileId: string;
  name: string;
  decryptionKey: string;
  upload: string;
};

type ResultProvidedProps = {
  unitId: string;
  resultId: string;
  itemId: string;
  title: string;
  body: string;
  type: string;
  segment: string;
  resultType: string;
  report: boolean;
  photo: boolean;
  result: string;
  startedAt: number;
  stoppedAt: number;
  userId: string;
  userName: string;
  skip: string;
  redo: string;
  prev: string;
  videos: ResultFile[];
  voices: ResultFile[];
  images: ResultFile[];
  editor: string;
  editorName: string;
  updatedAt: number;
  version: number;
};

export type ResultQueryParams = QueryParams & { projectId: string; unitId: string };

export type FileQueryParams = QueryParams & { projectId: string; unitId: string; resultId: string; fileId: string };

export type Result = ResultProvidedProps;

export class Results extends ImmutableMap<string, Result> {
  constructor(results?: Result[] | Iterable<Result>) {
    super((result: Result) => result.resultId, results);
  }

  protected clone(results?: Result[] | Iterable<Result>): this {
    return new Results(results) as this;
  }
}
